"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNil = void 0;
function isNil(x) {
    return x === null || x === undefined;
}
exports.isNil = isNil;
//# sourceMappingURL=common.js.map